<template>
  <div>
    <el-container class="main">
            <el-aside :width="tabWidth+'px'">
                <div>
                    <div class="isClossTab" @click="isClossTabFun">
                        <i :class="isCollapse?'el-icon-d-arrow-right':'el-icon-d-arrow-left'" ></i>
                    </div>
                    <PageMenu></PageMenu>
                </div>
            </el-aside>
            <el-container>
                <el-header class="main-header">
                    <el-col :span="17" style="height:100%;">
                        <el-row align="middle" justify="center" style="height:100%;font-size: 22px;letter-spacing:8px" type="flex">
                        客户工程师接待系统
                        </el-row>
                    </el-col>
                    <el-col :span="7">
                        <el-row align="middle" justify="end" type="flex">
                        你好，{{realName}}<!-- <span style="height:100%;">你好，周</span> -->
                        , 您有
                        <el-badge :value="unreadCount" style="margin: auto 20px auto 5px;" class="item" @click.native="$router.push('/message/')">
                            <div class="el-icon-message"></div>
                        </el-badge>
                        条未读消息
                        <el-dropdown style="padding-left:25px">
                            <span class="el-dropdown-link">
                                <img src="../static/images/head-sculpture.jpg" alt="">
                            </span>
                            <el-dropdown-menu slot="dropdown" >
                                <el-dropdown-item @click.native="$router.push('/user/info')">个人信息</el-dropdown-item>
                                <el-dropdown-item @click.native="$router.push('/user/resetPasswd')">修改密码</el-dropdown-item>
                                <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        </el-row>
                    </el-col>
                </el-header>
                <el-main>
                    <!-- <el-breadcrumb separator="/" class="crumbs">
                        <el-breadcrumb-item
                            v-for="(item,index) in breadList"
                            :key="index"
                            :to="{ path: item.path }">
                        {{item.meta.title}}
                        </el-breadcrumb-item>
                    </el-breadcrumb> -->
                    <!-- <el-button ref="audioTipsBtn" @click="audioPlay()">按钮</el-button> -->
                    <div>
                        <keep-alive >
                        <router-view v-if="$route.meta.keepAlive" @changeMsgCount="changeMsgCount" @addMsgCount="addMsgCount"/>
                        </keep-alive>
                        <router-view v-if="!$route.meta.keepAlive" @changeMsgCount="changeMsgCount" @addMsgCount="addMsgCount"/>
                        <!-- <router-view ></router-view> -->
                    </div>
                </el-main>
                <el-footer class="main-footer" height="10px">
                </el-footer>
            </el-container>
        </el-container>
        <audio ref="audio" id="audio" src="/static/tips.wav" style="display:none"></audio>
  </div>
</template>

<script>
import PageMenu from '@/components/PageMenu.vue'
import PageHeader from '@/components/PageHeader.vue'
import api from '@/util/api'
export default {
  name: 'Index',
  components: {
    PageMenu, PageHeader
  },
  data () {
    return {
        socket: null,
        timer: null,
        unreadCount: 0,
        realName: '',
        isCollapse: false,
        tabWidth: 200,
        test1: 1,
        intelval: null,
        breadList: [],
        tipsAudio: ''
    }
  },
//   watch: {
//     $route () {
//         this.getBreadcrumb()
//     }
//   },
  created () {
    //   this.reloadSocket()
      this.initWebSocket()
  },
  activated () {
  },
  mounted () {
      this.getBreadcrumb()
      this.getUserInfo()
      this.getUnreadMsgCount()
  },
  methods: {
    initWebSocket () {
        var user = api.getUserInfo()
        // let socketUrl = 'ws://localhost:8082/websocket/' + user.token
        // let socketUrl = 'ws://pc.zcping.com/websocket/' + user.token
        let socketUrl = 'ws://www.engineer-home.com/websocket/' + user.token
        this.socket = new WebSocket(socketUrl)
        this.socket.onopen = (msg) => {
            console.log('socket opened')
        }
        this.socket.onmessage = (event) => {
            console.log('onmessage:', event.data)
            this.showMsg(JSON.parse(event.data))
        }
        // var that = this
        this.socket.onclose = () => {
            console.log('socket 连接被关闭')
            // that.initWebSocket()
        }
        this.socket.onerror = () => {
            console.log('socket 连接错误')
            // that.initWebSocket()
        }
    },
    audioPlay () {
        const audio = this.$refs['audio']
        audio.play()
    },
    changeMsgCount (unreadCount) {
        this.unreadCount = unreadCount
    },
    addMsgCount (count) {
        this.unreadCount = this.unreadCount + count
        if (this.unreadCount < 0) {
            this.unreadCount = 0
        }
    },
    showMsg (data) {
        let title = data.title
        let content = data.msg
        this.addMsgCount(1)
        this.$notify({
            title: title,
            message: content,
            dangerouslyUseHTMLString: true,
            position: 'bottom-right',
            duration: 0
        })
        this.audioPlay()
    },
    handleOpen (key, keyPath) {
        console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
        console.log(key, keyPath)
    },
    isHome (route) {
        return route.name === '/'
    },
    logout () {
        this.$confirm('确定要退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            this.$http.postData('/api/admin/user/logout', {}).then(response => {
                localStorage.removeItem('user')
                this.$router.push('/login')
            })
        })
    },
    getUnreadMsgCount () {
        this.$http.postData('/api/admin/message/getUnReadMsgCount', {}).then(response => {
            this.unreadCount = response.unreadCount
        })
    },
    getBreadcrumb () {
        let matched = this.$route.matched
        // console.log(JSON.stringify(this.$route.path))
        // 如果不是首页
        // if (!this.isHome(matched[0])) {
        //   matched = [{path: '/', meta: {title: '首页'}}].concat(matched)
        // }
        this.breadList = matched
    },
    getUserInfo () {
        var user = api.getUserInfo()
        this.realName = user.realName
    },
    isClossTabFun () {
        clearInterval(this.intelval)
        if (!this.isCollapse) {
            this.intelval = setInterval(() => {
                if (this.tabWidth <= 64) {
                    clearInterval(this.intelval)
                }
                this.tabWidth -= 10
            }, 1)
            // this.tabWidth = 64
        } else {
            this.tabWidth = 200
        }
        this.isCollapse = !this.isCollapse
    }
  }
}
</script>

<style lang="scss">
$header-height: 60px;
$background-color: #545c64;
$color: #FFF;

.el-input--small {
    width: 210px;
}
.el-date-editor {
    width: 180px;
    .el-input__inner {
        width:190px;
    }
}
.main{
    height: 100vh;
    min-width: 800px;
    min-height: 600px;
    overflow: hidden;

    aside{
        overflow: visible;
        height: 100%;
        background-color: $background-color;
        color: $color;

        .isClossTab{
            width: 100%;
            height: $header-height;
            cursor: pointer;
            font-size: 25px;
            text-align: center;
            line-height: $header-height;
            font-weight: bold;
            border-right: 1px solid #807c7c;
            box-sizing: border-box;
        }
        .menu {
            width: 100%;
            border-right:0;
        }
        // .el-menu-item {
        //     min-width: 150px;
        // }

    }

    .main-header {
        background-color: $background-color;
        color: $color;

        .el-dropdown{
            cursor: pointer;
            float: right;
        }
        .el-dropdown-link{

            img{
                $imgMargin: (($header-height - 50)/2);
                display:inline-block;
                width:50px;
                height: 50px;
                border-radius: 25px;
                background-color: #FFF;
                margin-top: $imgMargin;
            }
        }
    }

    .crumbs {
        margin-bottom: 20px;
    }

    .main-footer{
        text-align: center;
        background-color: $background-color;
        color: $color;
        line-height: 20px;
    }

}
</style>



// WEBPACK FOOTER //
// src/views/index.vue